var map = {
	"./Discord.png": 9006,
	"./Email.png": 7285,
	"./Facebook.png": 3461,
	"./GitHub.png": 3891,
	"./Instagram.png": 1418,
	"./LinkedIn.png": 7697,
	"./Location.png": 2946,
	"./Medium.png": 970,
	"./Phone.png": 2842,
	"./Twitter.png": 3371
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8079;